import React from "react";
import { Form, Select } from "antd";
const requiredFieldRules = {
  required: true,
  message: "Поле, обязательное для заполнения"
};

const TaxSystem = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <div className="add-licensee__item">
      <span className="label">Система налогообложения:</span>
      <Form.Item>
        {getFieldDecorator("taxSystem", {
          rules: [requiredFieldRules]
        })(
          <Select
            getPopupContainer={trigger => trigger.parentNode}
            style={{ width: 224 }}
            placeholder="Выберите с или без НДС"
          >
            <Select.Option value={0}>Без НДС</Select.Option>
            <Select.Option value={1}>С НДС</Select.Option>
          </Select>
        )}
      </Form.Item>
    </div>
  );
};

export const OtherFields = ({ form }) => {
  return (
    <>
      <TaxSystem form={form} />
    </>
  );
};
